import { render, staticRenderFns } from "./two-column.vue?vue&type=template&id=72aed3f6&scoped=true&"
import script from "./two-column.vue?vue&type=script&lang=js&"
export * from "./two-column.vue?vue&type=script&lang=js&"
import style0 from "./two-column.vue?vue&type=style&index=0&id=72aed3f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aed3f6",
  null
  
)

export default component.exports